// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1HBVU","bigColWidth":"Table_bigColWidth__1N7rF","biggerColWidth":"Table_biggerColWidth__3Y2EJ","row":"Table_row__2VjhA","col":"Table_col__1opNM"};